<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-10 15:56:07
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-16 15:46:59
-->
<template>
  <div class="ToIntoing">
    <CustomHead srcName="loading.png">
      <div class="Transferring_in">正在{{ isText }}中…</div>
      <div class="Submitted">{{ isText }}申请已提交，银行正在努力处理中…</div>
    </CustomHead>
    <self-popup v-model="ShowPopupContent"></self-popup>
  </div>
</template>
<script>
import CustomHead from '@/components/CustomHead.vue';

export default {
  name: 'ToIntoing',
  data() {
    return {
      trans_no: '',
      isInto: '',
      timer: null,
      ShowPopupContent: '',
    };
  },
  components: {
    CustomHead,
  },
  computed: {
    isText() {
      return this.isInto === 'true' ? '转入' : '转出';
    },
  },
  mounted() {
    this.isInto = this.$router.currentRoute.query.isInto;
    this.trans_no = this.$router.currentRoute.query.trans_no;
    this.getHandleInfo();
  },
  methods: {
    getHandleInfo() {
      if (this.isText === '转入') {
        this.depositQuery();
      } else {
        this.transferQuery();
      }
    },
    depositQuery() {
      const SUCCESS_STATUS = '01';
      const FAILURE_STATUS = '02';
      const PROCESSING_STATUS = '03';
      // eslint-disable-next-line camelcase
      const { orderId, amount, trans_no } = this.$router.currentRoute.query;
      this.$api.CommonForms.depositQuery({
        orderId,
        transNo: trans_no,
      })
        .then((res) => {
          clearTimeout(this.timer);
          if (res.success) {
            if (res.data.deposit_status === PROCESSING_STATUS) {
              this.timer = setInterval(this.depositQuery, 3000);
            } else if (res.data.deposit_status === SUCCESS_STATUS) {
              clearTimeout(this.timer);
              this.$router.push(
                `/supermarket/v2/ToIntoSuccessIn?amount=${amount}&isText=${this.isText}&orderId=${orderId}`,
              );
            } else if (res.data.deposit_status === FAILURE_STATUS) {
              clearTimeout(this.timer);
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.data.ret_msg}&isText=${this.isText}&orderId=${orderId}&retCode=`,
              );
            }
          } else {
            if (!res.success && res.returnCode === 'EDC0002') {
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&isText=转出&orderId=${orderId}&retCode=${res.returnCode}`,
              );
            } else {
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&isText=${this.isText}&orderId=${orderId}&retCode=`,
              );
            }
            clearTimeout(this.timer);
          }
        })
        .catch(() => {
          this.IsShowPopup = true;
        });
    },
    transferQuery() {
      // eslint-disable-next-line camelcase
      const { orderId, amount, trans_no } = this.$router.currentRoute.query;
      const SUCCESS_STATUS = '0';
      const FAILURE_STATUS = '1';
      const PROCESSING_STATUS = '2';
      this.$api.CommonForms.transferQuery({
        orderId,
        transNo: trans_no,
      })
        .then((res) => {
          clearTimeout(this.timer);
          if (res.success) {
            if (res.data.transfer_status === PROCESSING_STATUS) {
              this.timer = setInterval(this.transferQuery, 3000);
            } else if (res.data.transfer_status === SUCCESS_STATUS) {
              clearTimeout(this.timer);
              this.$router.push(
                `/supermarket/v2/ToIntoSuccess?amount=${amount}&isText=${this.isText}&orderId=${orderId}`,
              );
            } else if (res.data.transfer_status === FAILURE_STATUS) {
              clearTimeout(this.timer);
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.data.ret_msg}&isText=${this.isText}&orderId=${orderId}&retCode=`,
              );
            }
          } else {
            if (!res.success && res.returnCode === 'EDC0002') {
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&isText=转出&orderId=${orderId}&retCode=${res.returnCode}`,
              );
            } else {
              this.$router.push(
                `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&isText=${this.isText}&orderId=${orderId}&retCode=`,
              );
            }
            clearTimeout(this.timer);
          }
        })
        .catch(() => {
          this.IsShowPopup = true;
          this.ShowPopupContent = '网络异常，请稍后再试！';
        });
    },
  },
};
</script>
<style scoped>
.Transferring_in {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
  margin: 20px 0 8px 0;
}
.Submitted {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9ea7b4;
}
@keyframes load-effect {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
